import React, {useCallback, useState} from 'react'

import DemoUpReact from 'demoup-react'
import TagManager from 'react-gtm-module'
import {palette} from 'styled-tools'
import {media} from 'styled-bootstrap-grid'
import styled, {css} from 'styled-components'

const textStyles = css`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: ${palette('blue')};
`

const DemoupWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  .demoup-trigger {
    width: 100%;
  }

  .demoup-trigger > div {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
  }

  .demoup-play {
    padding: 2px;
    border: 1px solid ${palette('border')};
    border-radius: 8px;
    background-color: ${palette('white')};

    ${media.md`
      padding: 0 16px 0 0;
      border-radius: 12px;
    `}
  }

  /* hide default icons */
  .demoupUI-img svg {
    display: none;
  }

  /* video button */
  .demoupUI-playimage {
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: none !important;

    .demoupUI-img {
      display: none;
      background-size: 20px;
      background-image: url('/icons/live-line.svg');
      background-repeat: no-repeat;
      background-position: center;
      height: 30px !important;

      ${media.md`
        display: initial;
      `}
    }

    &::after {
      content: 'Myndbönd';
      ${textStyles};
    }
  }

  /* 3D button */
  .demoupUI-3d-playimage {
    display: flex;
    align-items: center;
    justify-content: center;

    .demoupUI-img {
      display: none;
      background-size: 20px;
      background-image: url('/icons/box-3-line.svg');
      background-repeat: no-repeat;
      background-position: center;
      height: 30px !important;

      ${media.md`
        display: initial;
      `}
    }

    &::after {
      content: '3D/AR';
      ${textStyles};
    }
  }
`

interface DemoupContainerProps {
  videos: string[]
  videosAvailable: number
}

// use to test how it looks locally
export const testVideo = [
  'QmivaIo76Y4Xpg8Ik8e6exDik7iFN0',
  'vsdvRRLph5ZfAn0r3AaAyAytRF0hPV',
]

const enableAnalytics = false

interface Props {
  sku?: string
}

export default function Demoup({sku}: Props) {
  const {container: DemoupContainer, button: DemoupButton} =
    DemoUpReact('elko.is')

  const [videoLoaded, setVideoLoaded] = useState(false)
  const [threedLoaded, setThreedLoaded] = useState(false)

  const handleLoadDemoup = useCallback(() => {
    const handleVideoButtonClick = () => {
      TagManager.dataLayer({
        dataLayer: {
          event: 'pdp_video_btn_click',
          event_label: sku,
        },
      })
    }
    const handle3DButtonClick = () => {
      TagManager.dataLayer({
        dataLayer: {
          event: 'pdp_3d_btn_click',
          event_label: sku,
        },
      })
    }
    const handleLoadVideo = () => {
      setVideoLoaded(true)
      TagManager.dataLayer({
        dataLayer: {
          event: 'pdp_video_btn_load',
          event_label: sku,
        },
      })
    }
    const handleLoad3d = () => {
      setThreedLoaded(true)
      TagManager.dataLayer({
        dataLayer: {
          event: 'pdp_video_btn_load',
          event_label: sku,
        },
      })
    }

    const videoButton = document.querySelector('.demoupUI-playbutton')
    const threedButton = document.querySelector('.demoup-video-3d-button')

    !videoLoaded && videoButton && handleLoadVideo()
    !threedLoaded && threedButton && handleLoad3d()

    videoButton?.addEventListener('click', handleVideoButtonClick)
    threedButton?.addEventListener('click', handle3DButtonClick)

    return () => {
      videoButton?.removeEventListener('click', handleVideoButtonClick)
      threedButton?.removeEventListener('click', handle3DButtonClick)
    }
  }, [sku, videoLoaded, threedLoaded])

  const DemoupValues = (props: Partial<DemoupContainerProps>) => (
    <>
      {!!props?.videos?.length && (
        <DemoupWrapper
          onLoadCapture={() => enableAnalytics && handleLoadDemoup()}
        >
          <DemoupButton
            width={'fit-content'}
            height={36}
            threed="enabled"
            multibutton={false}
          />
        </DemoupWrapper>
      )}
    </>
  )

  return (
    <DemoupContainer threed="enabled" style={{width: '100%'}}>
      <DemoupValues />
    </DemoupContainer>
  )
}
